import type { AxiosResponse } from "axios";

import config from "@/common/config";

import ApiService from "./api.service";
import type { ApiResponse, BaseAuthResponse } from "./types";

type LogoutResponse = ApiResponse<{ redirectUrl: string }>;

export default {
  VERSION: config.api.versions.v2,

  user(): Promise<AxiosResponse<ApiResponse<BaseAuthResponse>>> {
    return ApiService.get("/auth/user", this.VERSION);
  },

  authenticateWithAuthTicket(ticket: string): Promise<AxiosResponse<ApiResponse<void>>> {
    return ApiService.post("/auth/authenticate-with-auth-ticket", { ticket }, this.VERSION);
  },

  logout(): Promise<AxiosResponse<LogoutResponse>> {
    return ApiService.post("/auth/logout", {}, this.VERSION);
  }
};
